module.exports = {uri: __webpack_public_path__ + "img/neuwaerts.png", width: 500, height: 486};